import { Injectable } from '@angular/core';

const ID_KEY   = 'active_list_id';
const NAME_KEY = 'active_list_name';

@Injectable({ providedIn: 'root' })
export class ActiveListService {
  private listId   = 0;
  private listName = 'Boodschappenlijst';

  constructor() {
    const storedId   = localStorage.getItem(ID_KEY);
    const storedName = localStorage.getItem(NAME_KEY);
    this.listId   = storedId ? parseInt(storedId, 10) : 0;
    this.listName = storedName ?? 'Boodschappenlijst';
  }

  getListId():   number { return this.listId; }
  getListName(): string { return this.listName; }

  setActive(id: number, name: string): void {
    this.listId   = id;
    this.listName = name;
    localStorage.setItem(ID_KEY,   String(id));
    localStorage.setItem(NAME_KEY, name);
  }

  reset(): void {
    this.setActive(0, 'Boodschappenlijst');
  }
}
